import { Button, ListGroup } from "react-bootstrap";

export const OfferingUserList = ({
	users = [],
	removeUser = console.log,
	entity,
}) => (
	<ListGroup className="p-1" data-testid="test-offeringUserList">
		{users?.length ? (
			users.map(({ email }, index) => (
				<ListGroup.Item key={`user-item-${index}`}>
					{email}
					<Button
						size="sm"
						variant="outline-primary"
						className="p-1 outline-primary float-end"
						onClick={() => removeUser({ email, entity })}
					>
						Remove
					</Button>
				</ListGroup.Item>
			))
		) : (
			<ListGroup.Item className="p-2 ps-3">
				No users assigned
			</ListGroup.Item>
		)}
	</ListGroup>
);
